var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3306 0C19.168 0 19.0216 0.0661927 18.9158 0.172511L15.2301 3.85791V3.51465H15.2313V2.3431C15.2313 1.04854 14.1799 0 12.8882 0H2.3431C1.04883 0 0 1.04854 0 2.3431V11.7155C0 13.0101 1.04883 14.0586 2.3431 14.0586H12.8882C14.1799 14.0586 15.2313 13.0101 15.2313 11.7155V10.5439H15.2301V10.2007L18.9158 13.8858C19.0216 13.9921 19.168 14.0586 19.3306 14.0586C19.6542 14.0586 19.9163 13.7965 19.9163 13.4728V0.585775C19.9163 0.262427 19.6542 0 19.3306 0ZM15.0591 8.37306C14.9534 8.26675 14.8069 8.20085 14.6444 8.20085C14.3207 8.20085 14.0586 8.46298 14.0586 8.78662V10.5439V11.1297V11.7155C14.0586 12.3613 13.534 12.8859 12.8882 12.8859H2.3431C1.69582 12.8859 1.17155 12.3613 1.17155 11.7155V2.3431C1.17155 1.69728 1.69582 1.17272 2.3431 1.17272H12.8882C13.534 1.17272 14.0586 1.69728 14.0586 2.3431V2.92887V3.51465V5.27197C14.0586 5.59561 14.3207 5.85775 14.6444 5.85775C14.8069 5.85775 14.9534 5.79185 15.0591 5.68553L18.7448 1.99983V12.0588L15.0591 8.37306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVc);
export default __webpack_public_path__ + "static/media/vc.9f28d316efb4e5320bcbc412954a7276.svg";
export { ForwardRef as ReactComponent };